import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';
import { AUTHENTICATION, ROUTES, } from '../../constants';
import { Box, Grid, MenuItem, Pagination, Select, Typography, InputLabel, FormControl, Stack, Button, styled, Switch, FormControlLabel } from '@mui/material';
import DataTable from '../../components/DataTable';
import { useDepartmentDropdownListQuery, useIssuesListMutation, useIssuesListDownloadMutation, useDeleteIssueByIdMutation } from '../../service/apiSlices/accessApiService';
import VisibilityIcon from '@mui/icons-material/Visibility';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { checkEmpty, nullUndefinedEmptyCheck } from '../../utils/helper';
import download from "../../assets/download.png";
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';


const Android12Switch = styled(Switch)(({ theme }) => ({
    padding: 8,
    '& .MuiSwitch-track': {
        borderRadius: 22 / 2,
        '&::before, &::after': {
            content: '""',
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            width: 16,
            height: 16,
        },
        '&::before': {
            backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
                theme.palette.getContrastText(theme.palette.primary.main),
            )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
            left: 12,
        },
        '&::after': {
            backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
                theme.palette.getContrastText(theme.palette.primary.main),
            )}" d="M19,13H5V11H19V13Z" /></svg>')`,
            right: 12,
        },
    },
    '& .MuiSwitch-thumb': {
        boxShadow: 'none',
        width: 16,
        height: 16,
        margin: 2,
    },
}));

const ManageIssue = () => {
    const navigate = useNavigate();
    const [page, setPage] = useState(1);
    const [totalPage, setTotalCount] = useState(0);
    const [rowPerPage, setRowPerPage] = useState(10);
    const [hasProducts, setHasProducts] = useState(false);
    const [IssueList, setIssueList] = useState([]);
    const [IssueListApi] = useIssuesListMutation();
    const [IssueListDownloadAPI] = useIssuesListDownloadMutation();
    const [IssueTrackerDelete] = useDeleteIssueByIdMutation();
    const [department, setDepartment] = useState(null);
    const [dateRange, setDateRange] = useState<any>([]);
    const { data: DeparmentList } = useDepartmentDropdownListQuery('');
    const [isFiltered, setIsFilterd] = useState(false);

    const rows: GridRowsProp = IssueList ?? [];

    const navigateEditValue = (id: any) => {
        navigate(ROUTES.MANAGEISSUE_View + `/${id}`)
    }
    /*Admin or Super-Admin Sidebar Condition*/
    const isSuperAdminToken = sessionStorage.getItem(AUTHENTICATION.SHARED.SUPER_ADMIN);

    useEffect(() => {
        GetIssueListApiCall();
    }, [page, rowPerPage, isFiltered])

    const GetIssueListApiCall = async () => {

        let payload: any = { page: page, limit: rowPerPage }
        if (nullUndefinedEmptyCheck(department)) payload = {
            ...payload, ...{ 'filter': { 'department': `${department}` } }
        }
        if (dateRange !== null && dateRange.length === 2) {
            payload = {
                ...payload, ...{
                    'filter': { 'date': { 'start': moment(dateRange[0]).format('YYYY-MM-DD'), 'end': moment(dateRange[1]).format('YYYY-MM-DD') }, 'department': `${nullUndefinedEmptyCheck(department) ? department : ''}` }
                }
            }
        }
        await IssueListApi(payload)
            .unwrap()
            .then((response) => {
                setIssueList(response?.result?.data);
                setTotalCount(response.result.total_page);
                setHasProducts(checkEmpty(response?.result?.data));
            })
            .catch(() => { })
    }


    const handleVisibilityChange = (id: string, isActive: boolean) => {
        IssueTrackerDelete(id)
            .then(response => {
                GetIssueListApiCall();
            })
            .catch(error => { });
    };

    const columns: GridColDef[] = [
        // {
        //     accessorKey: 'index',
        //     header: 'SR.No',
        //     size: 50,
        //     Cell: ({ row }: any) => {
        //         const pageIndex = pagination.pageIndex;
        //         const pageSize = pagination.pageSize;
        //         return (pageIndex * pageSize) + row.index + 1;
        //     },
        // },
        // {
        //     field: 'serial',
        //     headerName: 'S.No',
        //     width: 100,
        //     renderCell: (index: any) => (
        //         return (page * rowPerPage) + index + 1
        //     )
        // },
        { field: 'Issuer_name', headerName: 'Name', width: 150 },
        {
            field: 'department_name', headerName: 'Category Name', width: 200,
            renderCell: (params) => (
                <div style={{ display: 'flex', flexDirection: 'row', gap: '10px', alignItems: 'center' }}>
                    <img
                        src={params.row.department_icon}
                        alt="icon"
                        style={{ width: '40px', height: '40px', borderRadius: '50%', objectFit: 'cover', margin: '5px' }}
                    />
                    <Typography variant="caption" sx={{ fontSize: 14 }}>{params.row.department_name}</Typography>
                </div>
            ),
        },
        { field: 'report_location', headerName: 'Report Location', width: 230 },
        {
            field: 'report Id',
            headerName: 'Report ID',
            width: 100,
            renderCell: (params) => {
                return params.row.id;
            },
        },
        {
            field: 'risk_evaluation', headerName: 'Priority', width: 150,
            renderCell: (params) => (
                <div style={{ textTransform: 'capitalize' }}>
                    {params.row.risk_evaluation}
                </div>
            ),
        },
        {
            field: 'created_on', headerName: 'Issue Created Date', width: 150,
            renderCell: (params) => (
                <>
                    {moment(params.row.created_on).format('DD/MM/YYYY')}
                </>
            ),
        },
        {
            field: 'actions',
            headerName: 'Actions',
            width: 80,
            renderCell: (params) => (
                <>
                    <VisibilityIcon onClick={() => navigateEditValue(params.row.id)} style={{ cursor: 'pointer', marginTop: '10px' }} />
                </>
            ),
        },
        {
            field: 'status',
            headerName: 'Status',
            width: 150,
            renderCell: (params) => (
                <>
                    <Typography variant="caption" sx={{ fontSize: 14 }}>{getStatus(params?.row?.report_tracker)}</Typography>
                </>
            ),
        },
        {
            field: 'is_active',
            headerName: 'Report visibiltiy',
            width: 250,
            renderCell: (params) => (
                <>
                    <FormControlLabel
                        control={
                            <Android12Switch
                                checked={params.row.is_active}
                                onChange={(event) => handleVisibilityChange(params.row.id, event.target.checked)}
                            />
                        }
                        label={params.row.is_active ? "visible to user" : "invisible to user"}
                    />
                </>
            ),
        },
    ];

    const handleDownload = async () => {
        let payload: any = {}
        if (nullUndefinedEmptyCheck(department)) payload = {
            ...payload, ...{ 'filter': { 'department': `${department}` } }
        }
        if (dateRange !== null && dateRange.length === 2) {
            payload = {
                ...payload, ...{
                    'filter': { 'date': { 'start': moment(dateRange[0]).format('YYYY-MM-DD'), 'end': moment(dateRange[1]).format('YYYY-MM-DD') }, 'department': `${nullUndefinedEmptyCheck(department) ? department : ''}` }
                }
            }
        }
        await IssueListDownloadAPI(payload)
            .unwrap()
            .then((response) => {
                let link: any = document.createElement("a");
                link.setAttribute('download', 'donwload document');
                link.href = response.result.data[0];
                document.body.appendChild(link);
                link.click();
                link.remove();
            })
            .catch(() => { })
    }


    const getStatus = (data: any) => {
        // Check if all tracker_status values are "Pending"
        const allPending = data?.every((item: any) => !item?.is_status);

        if (allPending) {
            return 'Not yet viewed';
        }
        else if (data[data.length - 1].is_status) {
            return 'Completed';
        }
        else {
            return 'Pending'
        }
    }

    /**Handle row per page change */
    const onRowChange = (event: any) => {
        setPage(1);
        setRowPerPage(parseInt(event.target.value));
    };

    /* Handle page change */
    const handleChangePage = (event: React.ChangeEvent<any>, newPage: number) => {
        setPage(newPage);
    };


    const handleDateRangeSelect = (ranges: any) => {
        setDateRange(ranges);
    }

    const handleClearFilter = () => {
        setDepartment(null);
        setDateRange(null);
        setIsFilterd(false);
    }

    const handleApplyFilter = () => {
        if (nullUndefinedEmptyCheck(department) || (dateRange !== null && dateRange.length === 2)) {
            setIsFilterd(true);
            GetIssueListApiCall();
        }
    }

    return (
        <div>
            <Stack direction='row' alignItems='center'>
                <FormControl sx={{ m: 1, minWidth: 150 }}>
                    <InputLabel id="department-filter-label">Category</InputLabel>
                    <Select
                        labelId='department-filter-label'
                        id='department-filter'
                        label='Category'
                        value={department}
                        onChange={(event: any) => { setDepartment(event.target.value) }}
                    >
                        {DeparmentList?.result?.data.length > 0 &&
                            DeparmentList?.result?.data?.map((item: any, i: any) => {
                                return (
                                    <MenuItem key={i} value={item?.id}>{item?.name}</MenuItem>
                                )
                            })}
                    </Select>
                </FormControl>
                <Box sx={[{ position: 'relative' }]}>
                    <Typography variant='caption' sx={[{ position: 'absolute', top: '0px', left: '24px', backgroundColor: '#f7f6f8', zIndex: 1, color: '#00000099', px: "4px" }]}>Date range</Typography>
                    <DateRangePicker onChange={handleDateRangeSelect} value={dateRange} format='y-MM-dd' maxDate={moment().toDate()} dayPlaceholder='DD' monthPlaceholder='MM' yearPlaceholder='YYYY' />
                </Box>
                {isSuperAdminToken === 'true' &&
                    <Stack alignItems='center' justifyContent='center' component='div' sx={[{ borderRadius: '4px', border: '1px solid rgba(0, 0, 0, 0.23)', height: '56px', width: '56px', margin: '8px' }]}>
                        <Box onClick={handleDownload} component='img' src={download} width='24px' height='24px' sx={[{
                            cursor: 'pointer'
                        }]} />
                    </Stack>
                }

                <Button variant="text" sx={{ mt: 1, mr: 1 }} onClick={handleClearFilter}>Clear</Button>
                <Button variant="contained" sx={{ mt: 1, mr: 1 }} onClick={handleApplyFilter}>Apply</Button>
            </Stack>

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'flex-end'
                }}
            >
            </Box>
            <Box sx={{
                width: '100%'
            }}>
                <DataTable rows={rows} columns={columns} />
                {hasProducts && (
                    <div className="tablePagination">
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={7}>
                                <div className="pagination-wrap">
                                    <Pagination
                                        count={totalPage}
                                        page={page}
                                        onChange={handleChangePage}
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={5}>
                                <div className="rows-per-page">
                                    <p>Rows per page</p>
                                    <select
                                        className="rows-select"
                                        value={rowPerPage}
                                        onChange={onRowChange}
                                    >
                                        <option value={5}>5</option>
                                        <option value={10}>10</option>
                                        <option value={25}>25</option>
                                    </select>
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                )}
            </Box>
        </div >
    )
}

export default ManageIssue;